import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import AppWrapper from './components/AppWrapper';
import { Provider } from 'react-redux';
import { store,persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ApmRouteTracker } from './apmRouteTracker';
import keycloak from './auth/keycloak';

const hostname = window.location.hostname;
const isLocalEnv = hostname === 'localhost' || hostname === '127.0.0.1';

if (!isLocalEnv) {
  import('./apm');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

keycloak
  .init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  })
  .then(() => {
    console.log('I am working !!')
    root.render(
      <BrowserRouter>
        <ApmRouteTracker />
        <ConfigProvider theme={{ algorithm: theme.defaultAlgorithm }}>
          <AppWrapper>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <App />
              </PersistGate>
            </Provider>
          </AppWrapper>
        </ConfigProvider>
      </BrowserRouter>
    );
  })
  .catch((error) => {
    console.error('Keycloak initialization failed', error);
  });

reportWebVitals();